
import './bootstrap'

export default {}
